import { configureStore } from '@reduxjs/toolkit';

import authSlice from './auth/auth-slice';
import schedulingSlice from './scheduling/scheduling-slice';

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    scheduling : schedulingSlice.reducer
  }
});

export default store;
